import { Divider, FormControl, MenuItem, Select, TextField } from "@mui/material";
import React, { ReactElement, useState } from "react";
import "./InputPhoneEmail.scss";

interface CountryType {
  code: string;
  label: string;
  phone: string;
  suggested?: boolean;
}


interface PhoneNumberOrEmailInputPropsType {
  state: any[];
  setError: any;
  hasError: boolean;
  forceToPhone: boolean;
  forceToEmail: boolean;
  handleKeyDown: any;
  hasErrorServer: string;
  forceToGoogle: any;
  loggedWithThirdParty: boolean;
}

const PhoneNumberOrEmailInput: React.FC<PhoneNumberOrEmailInputPropsType> = (
  props: PhoneNumberOrEmailInputPropsType
): ReactElement => {
  const [country, setCountry] = useState<CountryType>({
    code: "FR",
    label: "France",
    phone: "33",
    suggested: true,
  });

  const {
    hasError,
    setError,
    state,
    forceToEmail,
    forceToPhone,
    handleKeyDown,
    forceToGoogle,
    loggedWithThirdParty,
  } = props;

  const [phoneEmailState, phoneEmailDispatcher] = state;
  const { filedInput, inputType } = phoneEmailState;

  const handleChange = (value: string) => {
    setError(false);

    if (country) {
      phoneEmailDispatcher("countryPrefix", country.phone);
    }

    if (
      (loggedWithThirdParty && !Number(value)) ||
      (forceToGoogle && !Number(value)) ||
      (forceToPhone && value && /[a-zA-Z]/.test(value))
    ) {
      return;
    }

    let sanitizedValue = value.trim();

    if (value && !/[a-zA-Z]/.test(value)) {
      sanitizedValue = value.replace(/\D/g, "");
    }

    phoneEmailDispatcher("filedInput", sanitizedValue);
    const newInputType = /[a-zA-Z]/.test(sanitizedValue) ? "email" : "tel";
    phoneEmailDispatcher("inputType", newInputType);
  };

  const renderValue = (selectedCountryCode: string) => (
    <img
      src={`https://hatscripts.github.io/circle-flags/flags/${selectedCountryCode.toLowerCase()}.svg`}
      style={{ margin: "6px 6px 0px 0px", width: 20 }}
    />
  );

  return (
    <FormControl
      variant="standard"
      fullWidth
      className="inputPhoneEmail"
      sx={{ display: "flex", flexDirection: "row", margin: "10px 0px" }}
    >
      <TextField
        className="inputField"
        sx={{ display: "flex", flexDirection: "row", height: "60px" }}
        error={hasError}
        fullWidth
        variant="standard"
        value={filedInput}
        onKeyDown={handleKeyDown}
        placeholder={
          forceToGoogle || loggedWithThirdParty
            ? "Votre numéro de téléphone"
            : !forceToEmail && !forceToPhone
              ? "Votre numéro de téléphone ou votre e-mail"
              : forceToEmail
                ? "Votre e-mail"
                : "Votre numéro de téléphone"
        }
        onChange={(e) => handleChange(e.target.value)}
        InputProps={
          !forceToEmail
            ? {
              startAdornment: (
                <FormControl
                  variant="standard"
                  className="countrySelector"
                  style={{
                    width: inputType === "tel" ? "190px" : "0px",
                  }}
                >
                  <Select renderValue={renderValue} sx={{ height: "100%" }} value="FR" disabled>
                    <MenuItem value="FR">
                      <img
                        src="https://hatscripts.github.io/circle-flags/flags/fr.svg"
                        alt="France"
                        style={{ marginRight: 8, width: 20 }}
                      />
                      France (+33)
                    </MenuItem>
                  </Select>
                  <Divider
                    style={{ height: "30px", margin: "auto" }}
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    sx={{ margin: "0 5px" }}
                  />
                </FormControl>
              ),
            }
            : {}
        }
      />
    </FormControl>
  );
};

export default PhoneNumberOrEmailInput;

